module.exports = __webpack_public_path__ + "static/logo-5b154ed7abb32d4e4aebc43085c60d23.png";